import React from "react";
import PropTypes from "prop-types";
import parse from "html-react-parser";

import style from "./style.module.scss";

export function Header(props) {
  return (
    <div className={`${style.sliderHeader} ${props.className} `}>
      {parse(props.text)}
    </div>
  );
}

Header.propTypes = {
  /**
   * classname
   */
  className: PropTypes.string,
  /**
   * text to be displayed in header
   */
  text: PropTypes.string,
};
